export default {
    enabled: {
        type: ["boolean"],
        default: () => true
    },
    title: {
        type: ["undefined", "string"]
    },
    order: {
        type: ["undefined", "number"]
    },
    description: {
        type: ["undefined", "string"]
    },
    authors: {
        type: ["undefined", "string"]
    },
    narrators: {
        type: ["undefined", "string"]
    },
    illustrators: {
        type: ["undefined", "string"]
    },
    price: {
        type: ["undefined", "number"]
    },
    euroPrice: {
        type: ["undefined", "number"]
    },
    publication: {
        type: ["undefined", "string"]
    },
    imageAddress: {
        type: ["undefined", "string"]
    },
    chapters: {
        type: ["array"],
        default: () => []
    }
};